import axios from 'axios'
import commonMethods from '@/commonMethods'

const { registerError } = commonMethods()

function getSlots(scheduleId, branchId, date) {
  return new Promise((resolve, reject) => {
    try {
      let url = `${process.env.VUE_APP_PATH}calendar/${scheduleId}/slots`
      axios
        .get(url, {
          params: {
            storeId: branchId,
            from: new Intl.DateTimeFormat('en-US').format(date)
          }
        })
        .then((response) => {
          resolve(response.data)
        })
    } catch (err) {
      registerError(err, 'Error en getSlots')
      reject(err)
    }
  })
}

export default getSlots
